import { useContext } from 'react';
import { Popup } from './common';
import { Item } from './components';
import { VerificationContext } from './providers';

export function Widget() {
  const { show } = useContext(VerificationContext);

  return (
    <Popup show={show}>
      <Item />
    </Popup>
  );
}
